"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RC_WIN = exports.RC_ON = exports.RC_LOSS = void 0;
var RC_LOSS = exports.RC_LOSS = "RC_LOSS";
var RC_WIN = exports.RC_WIN = "RC_WIN";
var RC_ON = exports.RC_ON = "RC_ON";
//# sourceMappingURL=types.js.map